const dom = {
  showFull: '.pdp__see-more',
  showLess: '.pdp__see-less',
  modal: '.pdp__modal',
  label: '.variant__label',
  defaultVariant: '.pdp_selector-input__default',
  accTrigger: '.accordion-item',
  showModal: '.show__modal',
  tabTrigger: '.tab__trigger',
  tabContent: '.tab__content',
  reviews: '.review-mobile',
};

const showFullContent = () => {
  const showBtns = document.querySelectorAll(dom.showFull);
  const hideBtns = document.querySelectorAll(dom.showLess);
  if (!showBtns || !hideBtns) return;
  showBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.target.closest('.pdp__description').classList.add('pdp__description-full');
      e.target.style.display = 'none';
    });
  });
  hideBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.target.closest('.pdp__description').classList.remove('pdp__description-full');
      showBtns.forEach((el) => {
        el.style.display = 'block';
      });
    });
  });
};
const changePrice = (price) => {
  const priceFields = document.querySelectorAll('.pdp__price');
  priceFields.forEach((el) => (el.innerHTML = price));
}

const variantSelector = () => {
  const variantInputs = document.querySelectorAll(dom.label);
  const defaultValue = document.querySelector(dom.defaultVariant);
  if (!variantInputs || !defaultValue) return;
  const productPrice = defaultValue.getAttribute('data-product-price');
  variantInputs.forEach((label) => {
    label.addEventListener('click', (e) => {
      const variantID = e.currentTarget.getAttribute('data-variant');
      const variantPrice = e.currentTarget.getAttribute('data-variant-price');
      if (document.getElementById(`${variantID}`).checked) {
        e.preventDefault();
        document.getElementById(variantID).checked = false;
        defaultValue.checked = true;
        changePrice(productPrice);
      } else {
        changePrice(variantPrice);
      }
    });
  });
};

const accordion = () => {
  const accHD = document.querySelectorAll(dom.accTrigger)
  accHD.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      accHD.forEach(item => {
        if (item !== e.currentTarget) {
          item.classList.remove('active');
        }
      })
      e.currentTarget.classList.toggle('active');
    });
  });
};

const stickySection = () => {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0 && window.innerWidth > 768) {
        entry.target.classList.add('isSticky');
      } else {
        entry.target.classList.remove('isSticky');
      }
    });
  });
  const boxElList = document.querySelectorAll('.pdp__form');
  if (!boxElList) return;
  boxElList.forEach((el) => {
    io.observe(el);
  });
};

const closeModal = () => {
  const modal = document.querySelector(dom.modal);
  modal.classList.remove('isOpen');
  document.body.style.overflow = 'auto';
  const tabs = document.querySelectorAll('.tab__trigger.active, .tab__content.active');
  tabs.forEach((tab) => {
    tab.classList.remove('active');
  });
};

const triggerModal = () => {
  const triggers = document.querySelectorAll(dom.showModal);
  const modal = document.querySelector(dom.modal);
  let selectedVariant;
  if (!triggers) return;
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      selectedVariant = e.target.getAttribute('data-variant-id');
      document.querySelector(`[data-tab-variant="${selectedVariant}"]`).classList.add('active');
      document.querySelector(`[data-content-variant="${selectedVariant}"]`).classList.add('active');
      modal.classList.add('isOpen');
      document.body.style.overflow = 'hidden';
    });
  });
  const closeBtns = document.querySelectorAll('.close');
  closeBtns.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      closeModal();
    });
  });
};

const modalTabs = () => {
  const tabNavs = document.querySelectorAll(dom.tabTrigger);
  const tabPanes = document.querySelectorAll(dom.tabContent);
  if (!tabNavs || !tabPanes) return;
  tabNavs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      const activeTabAttr = e.currentTarget.getAttribute('data-tab-variant');
      tabPanes.forEach((pane) => {
        const contentAttr = pane.getAttribute('data-content-variant');
        if (activeTabAttr === contentAttr) {
          tabNavs.forEach((el) => {
            el.classList.remove('active');
          });
          tabPanes.forEach((el) => {
            el.classList.remove('active');
          });
          pane.classList.add('active');
          tab.classList.add('active');
        }
      });
    });
  });
};

const addPackage = () => {
  const btns = document.querySelectorAll('.modal__details-atc');
  const modal = document.querySelector(dom.modal);
  if (!modal || !btns) return;
  btns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const variantID = e.currentTarget.getAttribute('data-variant-id');
      const variantPrice = e.currentTarget.getAttribute('data-variant-price');
      if (!document.getElementById(`${variantID}`).checked) {
        e.preventDefault();
        document.getElementById(`${variantID}`).checked = true;
        closeModal();
        changePrice(variantPrice);
      }
    });
  });
};

const modalPopup = () => {
  triggerModal();
  modalTabs();
  addPackage();
};

export const init = () => {
  if (window.innerWidth < 768 && document.querySelector(dom.reviews)) {
    document.querySelector(dom.reviews).innerHTML = `<div id="pwr-snippets" class="review-mobile"><div id="pr-reviewsnippet"></div></div>`;
  }
  showFullContent();
  variantSelector();
  stickySection();
  accordion();
  modalPopup();
};
